// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, HostBinding, OnDestroy, TemplateRef, ViewEncapsulation, computed, contentChild, forwardRef, input, viewChild } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SharedModule } from "primeng/api";
import { AutoFocusModule } from "primeng/autofocus";
import { ButtonModule } from "primeng/button";
import { RippleModule } from "primeng/ripple";
import { DateTime } from "luxon";
import { VButtonComponent } from "../button/button.component";
import { VDateModule } from "src/app/components/v-date/v-date.module";
import { VDatePickerBaseComponent } from "./datePicker.base.component";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { DatePickerConfig } from "./datePicker.config";
import { TranslateModule } from "@ngx-translate/core";
import { VIconComponent } from "src/app/components/v-icon/v-icon.component";

@Component({
    selector:      'v-date-picker',
    templateUrl:   './datePicker.component.haml',
    styleUrls:     ['./datePicker.component.sass', '../input.style.sass'],
    encapsulation: ViewEncapsulation.None,
    providers:     [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VDatePickerComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VDatePickerComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VDatePickerComponent), multi: true }
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ButtonModule,
        SharedModule,
        RippleModule,
        AutoFocusModule,
        VIconComponent,
        VDateModule,
        VButtonComponent,
        VDatePickerBaseComponent,
        TranslateModule
    ]
})
export class VDatePickerComponent extends InputFormWrapper<DatePickerConfig, DateTime> implements OnDestroy {
    protected _baseConfig: DatePickerConfig = DatePickerConfig.baseTheme.Default;

    public disabledDates = input<DateTime[]>();
    public minDate = input<DateTime>();
    public maxDate = input<DateTime>();

    private readonly labelTpl = viewChild<TemplateRef<unknown>>("labelTpl");
    private readonly defaultTpl = viewChild<TemplateRef<unknown>>("defaultTpl");
    private readonly inlineTpl = viewChild<TemplateRef<unknown>>("inlineTpl");
    public readonly headerTpl = contentChild<TemplateRef<unknown>>('header');
    public readonly footerTpl = contentChild<TemplateRef<unknown>>('footer');
    public readonly buttonBarTpl = contentChild<TemplateRef<unknown>>('buttonBar');

    public template = computed(() => {
        switch(this.config().display) {
            case 'inline':
                return this.inlineTpl();
            case 'label':
                return this.labelTpl();
            default:
                return this.defaultTpl();
        }
    });

    @HostBinding("class.v-date-picker-as-label") get asLabel() {
        return this.config().display === "label";
    }

    updateModel(_value?: DateTime): void {
        const el = (this.wrappedComponent as VDatePickerBaseComponent);
        el?.cd.markForCheck();
        el?.cd.detectChanges();
    }
}